import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { of, combineLatest } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { Selectors } from 'store/root-reducer';
import { CustomerService } from 'modules/core/services/customer.service';
import { SnackbarService } from 'app/services/snackbar.service';
var CustomerInDomainGuard = /** @class */ (function () {
    function CustomerInDomainGuard(router, store, customerService, snackBar) {
        this.router = router;
        this.store = store;
        this.customerService = customerService;
        this.snackBar = snackBar;
    }
    CustomerInDomainGuard.prototype.canActivate = function (activatedRouteSnapshot) {
        var _this = this;
        return combineLatest([
            this.store.select(Selectors.domain.getCurrentDomain),
            this.store.select(Selectors.customer.getCustomer)
        ])
            .pipe(switchMap(function (_a) {
            var domain = _a[0], currentCustomer = _a[1];
            if (currentCustomer && currentCustomer.id === activatedRouteSnapshot.params['id']) {
                return of(currentCustomer.domains.includes(domain.id));
            }
            else {
                return _this.customerService
                    .getCustomer(+activatedRouteSnapshot.params['id'])
                    .pipe(map(function (customer) { return customer.domains.includes(domain.id); }));
            }
        }), map(function (customerInDomain) {
            if (customerInDomain) {
                return true;
            }
            else {
                _this.router.navigateByUrl('/customers');
                _this.snackBar.error('The customer you were trying to access does not exist or does not belong to the current domain.');
                return false;
            }
        }), catchError(function (error) {
            _this.router.navigateByUrl('/customers');
            _this.snackBar.error('The customer you were trying to access does not exist or does not belong to the current domain.');
            return of(false);
        }));
    };
    return CustomerInDomainGuard;
}());
export { CustomerInDomainGuard };
